import React, { FC } from 'react'

import * as S from './ProgressBar.styles'

interface ProgressBarProps {
  progressPercentage: number
}

export const ProgressBar: FC<ProgressBarProps> = ({ progressPercentage }) => {
  const containerWidth = 75
  const barWidth = progressPercentage ? progressPercentage * containerWidth : 0

  return (
    <S.ProgressContainer>
      <S.Progress width={containerWidth}>
        <S.Bar width={barWidth} />
      </S.Progress>
      <S.ProgressValue>
        {progressPercentage ? (progressPercentage * 100).toFixed(0) : 0}%
      </S.ProgressValue>
    </S.ProgressContainer>
  )
}
